export default __webpack_public_path__ + "static/media/check.b8275eec.svg";